// extracted by mini-css-extract-plugin
module.exports = {"notesButton":"NotesButton_notesButton__FqCer"};